import { render, staticRenderFns } from "./PriceConfigDialog.vue?vue&type=template&id=1cccc8f4&scoped=true"
import script from "./PriceConfigDialog.vue?vue&type=script&lang=js"
export * from "./PriceConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceConfigDialog.vue?vue&type=style&index=0&id=1cccc8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cccc8f4",
  null
  
)

export default component.exports